import React from 'react'
import { CgClose } from 'react-icons/cg'
import { HiOutlineMenu } from 'react-icons/hi'
import { NavLink } from 'react-router-dom'
import styles from "./Home.module.css"
import LogoItem from "../Logo/LogoItem"

const Header = ({showMenu,setShowMenu,scrollTo,scrolled = false, hideLinks = false}) => {

    const handleNavClick = (id) => {
        setShowMenu(!showMenu)
        scrollTo(id)
    }

    return (
        <header className = {`${scrolled ? styles.scrolledHeader : ""}`}>
            <div className = {styles.headerContent}>
                <LogoItem/>
                {!hideLinks && <div className = {styles.links}>
                    <a href = "#about">About</a>
                    <a href = "#works">How it works</a>
                    <a href = "#features">Features</a>
                </div>}
                <div className = {styles.btns}>
                    <NavLink to = "/login" className = {styles.loginBtn}>Login</NavLink>
                    <NavLink to = "/signup" className = {styles.signupBtn}>Sign up</NavLink>
                    <div className= {styles.menuWrapper}>
                        {showMenu ? <div className = {styles.closeBtn} onClick = {()=>setShowMenu(false)}>
                        <CgClose/>
                        </div> 
                        : <div className = {styles.menuBtn} onClick = {()=>setShowMenu(true)}>
                        <HiOutlineMenu/>
                        </div>}
                        {showMenu && <div className = {styles.menu}>
                            {!hideLinks && <div className = {styles.links}>
                                <button type = "button" onClick = {()=>handleNavClick("about")}>About</button>
                                <button type = "button" onClick = {()=>handleNavClick("works")}>How it works</button>
                                <button type = "button" onClick = {()=>handleNavClick("features")}>Features</button>
                            </div>}
                            <div className = {styles.menuBtns}>
                                <NavLink to = "/login" className = {styles.loginBtn}>Login</NavLink>
                                <NavLink to = "/signup" className = {styles.signupBtn}>Sign up</NavLink>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </header>
  )
}

export default Header